/**
 * Created by sagardesai on 02/07/18.
 */
import {LogException} from "./utility";

export const checkIfTrendingBroadcastListAvailable = (props) => {
    return (props.hasOwnProperty("broadcaster_detail_management") &&
    props.broadcaster_detail_management.hasOwnProperty("trendingBroadcasters") &&
    props.broadcaster_detail_management.trendingBroadcasters &&
    props.broadcaster_detail_management.trendingBroadcasters !== null  &&
    props.broadcaster_detail_management.trendingBroadcasters.data.hasOwnProperty("data") &&
    props.broadcaster_detail_management.trendingBroadcasters.data.data !== null &&
    props.broadcaster_detail_management.trendingBroadcasters.data.data.length > 0)
}

export const checkIfSimilarBroadcastersListAvailable = (props) => {
    return (props.hasOwnProperty("broadcaster_detail_management") &&
    props.broadcaster_detail_management.hasOwnProperty("similarBroadcasters") &&
    props.broadcaster_detail_management.similarBroadcasters &&
    props.broadcaster_detail_management.similarBroadcasters !== null  &&
    props.broadcaster_detail_management.similarBroadcasters.data.hasOwnProperty("data") &&
    props.broadcaster_detail_management.similarBroadcasters.data.data !== null &&
    props.broadcaster_detail_management.similarBroadcasters.data.data.length > 0)
}

export const  formatBroadacastJson = (jsonData) =>  {

    var broadcast = {
        id :jsonData.id,
        is_verified: jsonData.hasOwnProperty("is_verified") ? jsonData.is_verified : 1,
        session_title : jsonData.session_title,
        session_description : jsonData.session_description,
        broadcast_type : jsonData.broadcast_type,
        type: jsonData.type,
        one_to_one_session_allow : jsonData.one_to_one_session_allow,
        one_to_one_session_price : jsonData.one_to_one_session_price,
        group_session_price : jsonData.group_session_price,
        tokbox_broadcast_url : jsonData.tokbox_broadcast_url,
        broadcast_start_at : jsonData.broadcast_start_at,
        broadcast_end_at : jsonData.broadcast_end_at,
        is_chat_allowed : jsonData.is_chat_allowed,
        viewers_count : jsonData.viewers_count,
        is_hls : jsonData.is_hls,
        is_following : jsonData.is_following,
        request : jsonData.request
    }

    if (!Array.isArray(jsonData.private)) {
        broadcast.private = jsonData.private
    }

    const data = {
        id : jsonData.broadcaster.id,
        age_group:jsonData.age_group,
        username : jsonData.broadcaster.username,
        profile_pic : jsonData.broadcaster.profile_pic,
        channel_description : jsonData.broadcaster.channel_description,
        channel_image_square : jsonData.broadcaster.channel_image_square,
        channel_image_rectangle : jsonData.broadcaster.channel_image_rectangle,
        channel_image : jsonData.broadcaster.channel_image,
        statueCode: jsonData.broadcaster.status,
        status : jsonData.broadcaster.status === 0 ? "offline" : jsonData.broadcaster.status === 1 ? "online" : "private",
        followers_count : jsonData.broadcaster.followers_count,
        is_following : jsonData.is_following,
        tags: jsonData.broadcaster.tags,
        broadcast : [broadcast],
        tip_goal: jsonData.tip_goal
    }

    return data
}

export const getEncryptedIdForBroadcaster = (broadcaster_id) => {
    return btoa(`broadcaster_broadcast_${broadcaster_id}`);
}

export const decodeEncryptedIdForBroadcaster = (encodedBroadcastID) => {

    try {
        const decodedString = atob(encodedBroadcastID);
        if (decodedString && decodedString.length > 0) {
            return decodedString.replace('broadcaster_broadcast_', '');
        } else {
            return -1
        }
    } catch (e) {
        LogException(e);
        return -1
    }
}